import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Fundo,
  Grupo,
  GrupoPost,
  Usuario,
} from './editar-grupo-de-investimento.model';
const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root',
})
export class EditarGrupoDeInvestimentoService {
  constructor(private _$http: HttpClient) {}

  postInvestmentGroup(Grupo: GrupoPost) {
    return (
      this._$http
        .put(`${BASE_PATH}/bff/master/investmentGroup/update`, Grupo)
        //.put(`http://localhost:4004/grupos/${id}`, Grupo)
        .toPromise()
    );
  }

  getFounds(payload: any) {
    return this._$http
      .post(`${BASE_PATH}/bff/master/investmentGroup/view`, payload)
      .toPromise();
  }
}
